module.exports = __webpack_public_path__ + "img/heroFormActive.859f13c1.png";